export default (
  state = {
    dealCounts: [],
    documentTyes: [],
    pipelineDocs: [],
    wonDeals: null,
    lostDeals: null,
    highValueDeals: [],
    soldProducts: [],
    accounts: [],
    leaderboard: [],
    dealValues: [],
    dealValuesByMonths: [],
  },
  action,
) => {
  switch (action.type) {
    case "DASHBOARD_DOC_DEALS":
      return {
        ...state,
        dealCounts: action.payload.dealFrequencies,
        documentTyes: action.payload.documentTyes,
        pipelineDocs: action.payload.pipelineDocs,
      };
    case "DASHBOARD_DEAL_VALUES":
      return {
        ...state,
        wonDeals: action.payload.wonDeals,
        lostDeals: action.payload.lostDeals,
        dealValues: action.payload.response.WonLostDealData,
        dealValuesByMonths: action.payload.DealValuesByMonths,
      };
    case "DASHBOARD_SOLD_PRODUCTS":
      return {
        ...state,
        soldProducts: action.payload.SoldProducts,
      };
    case "DASHBOARD_ACCOUNTS":
      return {
        ...state,
        accounts: action.payload.PipelineAccounts,
      };
    case "DASHBOARD_LEADERBOARD":
      return {
        ...state,
        leaderboard: action.payload.Leaderboard,
      };
    case "DASHBOARD_HIGH_VALUE_DEALS":
      return {
        ...state,
        highValueDeals: action.payload.HighValueDeals,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/DashboardReducer.js